import React from "react";

const NotFound = () => {
  return (
    <div>
      <h1>Not Found</h1>
      <p className="lead">The Page You Are Looking For Does Not Exist...</p>
    </div>
  );
};

export default NotFound;
